/* eslint-disable consistent-return */
/* eslint-disable default-case */
import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { QueryContext } from '../../contexts';
import ACTIONS from '../../constants/actions';

const QueryProvider = ({ children }) => {
  const initialQuery = {
    age: null,
    status: null,
    ret_age: null,
    income: null,
    married: null,
    dependents: null,
    worry: null,
    hope: null,
  };

  const queryReducer = (query, action) => {
    switch (action.type) {
      case ACTIONS.SET_PERSONAL_INFO:
        return {
          ...query,
          age: parseInt(action.payload.age, 10),
          status: action.payload.status,
          ret_age: parseInt(action.payload.ret_age, 10),
        };
      case ACTIONS.SET_HOUSEHOLD_INFO:
        return {
          ...query,
          married: action.payload.married,
          dependents: action.payload.dependents,
        };
      case ACTIONS.SET_GOALS:
        return {
          ...query,
          worry: action.payload.worry,
          hope: action.payload.hope,
        };
      case ACTIONS.RESET_FORM:
        return initialQuery;
    }
  };

  const [query, queryDispatch] = useReducer(queryReducer, initialQuery);

  return (
    <QueryContext.Provider
      value={{
        query,
        queryDispatch,
      }}
    >
      {children}
    </QueryContext.Provider>
  );
};

QueryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default QueryProvider;
